/**
 * Cross Navigation Link
 *
 * A styled link component for navigating between related pages.
 * Used in PageInfoBanner to show contextual links.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';

interface CrossNavigationLinkProps {
  /** Link text to display */
  label: string;
  /** Target URL */
  href: string;
}

/**
 * CrossNavigationLink Component
 *
 * Renders a subtle link with an arrow icon to related pages.
 * Styled to match the application's design system.
 *
 * @example
 * ```tsx
 * <CrossNavigationLink
 *   label="DD configuratie"
 *   href="/settings"
 * />
 * ```
 */
export const CrossNavigationLink: React.FC<CrossNavigationLinkProps> = ({ label, href }) => {
  return (
    <Link
      to={href}
      className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
    >
      <span>{label}</span>
      <ArrowRight size={14} weight="bold" />
    </Link>
  );
};
